/* eslint-disable no-shadow */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import {
  closeWarningDialog,
  returnToEdit,
  resetReturnToEdit,
  resetTriggeredByNewSelection,
} from '../state/warningDialog';

class WarningDialog extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  handleClose() {
    const { closeWarningDialog } = this.props;
    closeWarningDialog();
  }

  handleReturnToEdit() {
    const { returnToEdit, resetTriggeredByNewSelection } = this.props;

    returnToEdit();
    resetTriggeredByNewSelection();
    this.handleClose();
  }

  handleDiscardChange() {
    const { resetReturnToEdit } = this.props;

    resetReturnToEdit();
    this.handleClose();
  }

  render() {
    const { isWarningDialogOpened, triggeredByNewSelection } = this.props;
    return (
      isWarningDialogOpened && (
        <Dialog
          id="AssetDetails.WarningDialog"
          open={isWarningDialogOpened}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="AssetDetails.WarningDialog.Title">Edit asset</DialogTitle>
          <DialogContent>
            {triggeredByNewSelection ? (
              <DialogContentText id="AssetDetails.WarningDialog.SelectDescription">
                {"You have unsaved edits in the preview panel. Select 'Return to Edit' to continue editing, or 'Discard' to discard changes."}
              </DialogContentText>
            ) : (
              <DialogContentText id="AssetDetails.WarningDialog.WarningDescription">
                Your unsaved changes will be discarded.
              </DialogContentText>
            )}
          </DialogContent>
          {triggeredByNewSelection ? (
            <DialogActions>
              <Button
                id="AssetDetails.WarningDialog.Actions.ReturnToEdit"
                onClick={this.handleReturnToEdit}
                color="primary"
                autoFocus
              >
                Return to Edit
              </Button>
              <Button
                id="AssetDetails.WarningDialog.Actions.DiscardChange"
                onClick={this.handleDiscardChange}
                color="primary"
              >
                Discard
              </Button>
            </DialogActions>
          ) : (
            <DialogActions>
              <Button
                id="AssetDetails.WarningDialog.Actions.Confirm"
                onClick={this.handleClose}
                color="primary"
                autoFocus
              >
                OK
              </Button>
            </DialogActions>
          )}
        </Dialog>
      )
    );
  }
}

WarningDialog.propTypes = {
  closeWarningDialog: PropTypes.func.isRequired, // supplied from Redux
  resetReturnToEdit: PropTypes.func.isRequired, // supplied from Redux
  returnToEdit: PropTypes.func.isRequired, // supplied from Redux
  resetTriggeredByNewSelection: PropTypes.func.isRequired, // supplied from Redux
  isWarningDialogOpened: PropTypes.bool.isRequired, // supplied from Redux
  triggeredByNewSelection: PropTypes.bool.isRequired, // supplied from Redux
};

const mapStateToProps = (state) => ({
  isWarningDialogOpened: state.warningDialog.isWarningDialogOpened,
  triggeredByNewSelection: state.warningDialog.triggeredByNewSelection,
});

const mapDispatchToProps = {
  closeWarningDialog,
  resetReturnToEdit,
  returnToEdit,
  resetTriggeredByNewSelection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WarningDialog);
